import * as React from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {EpmsPaymentNotFound} from '../elements/EpmsPaymentNotFound'
import {RetryPayment} from '../../common/elements/RetryPayment'
import {FooterInfo} from '../../common/elements/FooterInfo'

///////////////////////////////////////////////////////////////////////////////

export const EpmsPaymentNotFoundBlock = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const showRetryPaymentButton = api.resolveConfigWithSingleResult<boolean>(
    'showRetryPaymentButton',
  )
  const retryPaymentText = api.trans(
    'blocks.epms_payment_not_found.retry_payment',
  )

  return (
    <section className="widget-block epms-payment-not-found-block">
      <div className="widget-block-content">
        <EpmsPaymentNotFound />
        {showRetryPaymentButton && (
          <RetryPayment
            text={retryPaymentText}
            className="retry-payment-line"
          />
        )}
      </div>
      <FooterInfo />
    </section>
  )
})
